import { render, staticRenderFns } from "./SportOrganizationsStoreItemContainer.vue?vue&type=template&id=0603c813&scoped=true"
import script from "./SportOrganizationsStoreItemContainer.vue?vue&type=script&lang=js"
export * from "./SportOrganizationsStoreItemContainer.vue?vue&type=script&lang=js"
import style0 from "./SportOrganizationsStoreItemContainer.vue?vue&type=style&index=0&id=0603c813&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0603c813",
  null
  
)

export default component.exports